import { get } from "lodash"
import type { CloudBluePlan } from "@gatsby-plugin-definitions/fragments/CloudBluePlan"
import type { SaleConfiguration } from "~/fragments/saleConfigurations"
import isEmpty from "~/lib/isEmpty"

export const getDefaultPlanData = (
  saleConfiguration: SaleConfiguration,
  defaultCloudBluePlanData: CloudBluePlan["flatData"]
): CloudBluePlan["flatData"] => {
  const controls = get(saleConfiguration, "flatData.config.controls[0].options")

  const selectedControl = controls.find((control) => control.selected)

  if (!isEmpty(selectedControl)) {
    const optionsMapping = saleConfiguration.flatData.optionsMapping || []

    const selectedOption = optionsMapping.find((option) => {
      const optionValueArray = option.value.match(/(.*)\[(\d+)\]/)

      if (isEmpty(optionValueArray)) {
        return false
      }

      const optionValue = optionValueArray[2]

      return optionValue === selectedControl.value
    })

    if (!isEmpty(selectedOption) && !isEmpty(selectedOption.cloudBluePlan)) {
      return selectedOption.cloudBluePlan[0].flatData
    }
  }

  return defaultCloudBluePlanData
}
